<app-search></app-search>
<!-- todo: make pretty -->
<div class="row" style="margin:10px 0px;" *ngIf="!loading">
  <ng-template ngFor let-key [ngForOf]="orgMeta.display_fields">
    <div class="col-md-3">
        <app-dynamic-input [meta]="orgMeta" [item]="orgItem" [key]="key"></app-dynamic-input>
    </div>
  </ng-template>
    <div class="col-md-12" style="margin-top:10px">
        <button class="btn btn-primary pull-right" (click)="save(organizationService, orgItem)">Save</button>
    </div>

</div>
<div class="row" style="margin:10px 0px;" *ngIf="!peopleLoading">
    <div class="col-md-12">
        <div class="panel panel-default">
            <app-nested-inline [meta]="peopleMeta"
                            [items]="peopleItem"
                            [foreignKey]="organization"></app-nested-inline>
        </div>
    </div>
</div>
<div class="row" style="margin:10px 0px;" *ngIf="!criteriaLoading">
    <div class="col-md-12">
        <div class="panel panel-default" >
            <app-nested-inline [meta]="criteriaMeta"
                            [items]="criteriaItem"
                            [foreignKey]=""></app-nested-inline>
        </div>
    </div>
</div>
<div class="row" style="margin:10px 0px;" *ngIf="!orderLoading">
    <div class="col-md-12">
        <div class="panel panel-default">
            <app-nested-inline [meta]="orderMeta" [parentItem]="{globalid: '1'}"
                            [items]="orderItem" [foreignKey]=""></app-nested-inline>
        </div>
    </div>
</div>
<div class="row" style="margin:10px 0px;" *ngIf="!reportLoading">
    <div class="col-md-12">
        <div class="panel panel-default">
            <app-nested-inline  [meta]="reportMeta" [items]="reportItem" [foreignKey]=""></app-nested-inline>
        </div>
    </div>
</div>
